import React from "react";
import { useI18n } from "../i18n";

const previewPosts = [
  {
    titleKey: "blog.preview.1.title",
    descKey: "blog.preview.1.desc",
    category: "Guide",
    slug: "best-ai-chatbot-malaysian-business-2026",
  },
  {
    titleKey: "blog.preview.2.title",
    descKey: "blog.preview.2.desc",
    category: "Guide",
    slug: "chatbot-pricing-malaysia-guide",
  },
  {
    titleKey: "blog.preview.3.title",
    descKey: "blog.preview.3.desc",
    category: "Use Case",
    slug: "ai-chatbot-ecommerce-shopee-lazada-malaysia",
  },
];

export function BlogPreview() {
  const { t } = useI18n();

  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex items-center justify-between mb-12">
          <div>
            <h2 className="text-3xl font-bold text-white mb-2">
              {t("blog.preview.title")}
            </h2>
            <p className="text-[#8a7a9a]">
              {t("blog.preview.subtitle")}
            </p>
          </div>
          <a
            href="/blog"
            className="hidden md:inline-block px-6 py-2.5 border border-[#2a2040] hover:border-[#a078d0]/50 text-[#c0a0e0] rounded-lg transition-colors text-sm"
          >
            {t("blog.preview.viewAll")} →
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {previewPosts.map((post) => (
            <a
              key={post.slug}
              href={`/blog/${post.slug}`}
              className="group rounded-xl onyx-card onyx-glow-hover p-6 block"
            >
              <span className="text-xs px-2 py-1 rounded-full bg-[#a078d0]/10 text-[#c0a0e0] border border-[#7b5ea7]/30 inline-block mb-4">
                {post.category}
              </span>
              <h3 className="text-lg font-semibold text-white mb-2 group-hover:text-[#c0a0e0] transition-colors line-clamp-2">
                {t(post.titleKey)}
              </h3>
              <p className="text-sm text-[#8a7a9a] line-clamp-3">
                {t(post.descKey)}
              </p>
              <span className="inline-block mt-4 text-sm text-[#a078d0] group-hover:text-[#c0a0e0] transition-colors">
                {t("blog.preview.readMore")} →
              </span>
            </a>
          ))}
        </div>

        <div className="mt-8 text-center md:hidden">
          <a
            href="/blog"
            className="inline-block px-6 py-2.5 border border-[#2a2040] hover:border-[#a078d0]/50 text-[#c0a0e0] rounded-lg transition-colors text-sm"
          >
            {t("blog.preview.viewAll")} →
          </a>
        </div>
      </div>
    </section>
  );
}
